import { useEffect, useMemo, useState } from "react";

export interface Command {
  id: string;
  label: string;
  hint?: string;
  run: () => void;
}

export function CommandPalette({ commands, onClose }: { commands: Command[]; onClose: () => void }) {
  const [query, setQuery] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return commands;
    return commands.filter((c) => c.label.toLowerCase().includes(q));
  }, [commands, query]);

  useEffect(() => setActiveIndex(0), [query]);

  function run(cmd: Command | undefined) {
    if (!cmd) return;
    onClose();
    cmd.run();
  }

  return (
    <div className="gm-modal-scrim" style={{ zIndex: 40 }} onClick={onClose}>
      <div
        className="gm-modal gm-in"
        style={{ width: 520, marginTop: "12vh" }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === "ArrowDown") { e.preventDefault(); setActiveIndex((i) => Math.min(i + 1, filtered.length - 1)); }
          if (e.key === "ArrowUp") { e.preventDefault(); setActiveIndex((i) => Math.max(i - 1, 0)); }
          if (e.key === "Enter") { e.preventDefault(); run(filtered[activeIndex]); }
          if (e.key === "Escape") onClose();
        }}
      >
        <input
          className="input"
          style={{ border: "none", borderBottom: "1px solid var(--gm-line-soft)", borderRadius: 0, padding: 14 }}
          placeholder="Type a command…"
          autoFocus
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <div style={{ maxHeight: 360, overflowY: "auto", padding: 6 }}>
          {filtered.map((c, i) => (
            <div
              key={c.id}
              className="gm-nav-row"
              data-active={i === activeIndex}
              onMouseEnter={() => setActiveIndex(i)}
              onClick={() => run(c)}
            >
              {c.label}
              {c.hint && <span className="gm-nav-count">{c.hint}</span>}
            </div>
          ))}
          {filtered.length === 0 && <div style={{ padding: 11, color: "var(--gm-text-4)", fontSize: 12.5 }}>No matching commands.</div>}
        </div>
      </div>
    </div>
  );
}
